import { CAMPAIGN_PLACEHOLDERS, placeholderMapping } from "../constants/helpers";
import { DisabledFieldsType } from "../types/dataTypes";

export const dateFormatter = (date: string) => {
  const inputDate = new Date(date);

  const months = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
  ];

  const day = inputDate.getDate();
  const month = inputDate.getMonth(); // This will give a number between 0 and 11
  const year = inputDate.getFullYear();

  return `${day} ${months[month]} ${year}`;
}

export const listDateFormatter = (dateString: string) => {
  const date = new Date(dateString);

  const day = date.getDate();
  const month = new Intl.DateTimeFormat('en-US', { month: 'long' }).format(date);
  const year = date.getFullYear();

  const hours = date.getHours();
  const minutes = date.getMinutes();

  const ampm = hours >= 12 ? 'PM' : 'AM';
  const formattedTime = `${hours % 12 === 0 ? 12 : hours % 12}:${minutes.toString().padStart(2, '0')} ${ampm}`;

  return `${day} ${month} ${year}\n${formattedTime}`;
}

export const getErrorContent = (profanityWords: string[], htmlContent: string) => {
  let updatedEmail = htmlContent;
  const regex = new RegExp(`\\b(${profanityWords.join('|')})\\b`, 'gi');
  // Replace matched words with <span> tags
  updatedEmail = updatedEmail.replace(regex, (match) => {
    return `<span style="color: #E03923; padding: 2px; background-color: #FCEBE9">${match}</span>`;
  });
  return updatedEmail;
}


export const extractDomain = () => {
  let domain = "";
  const url = window.location.origin;
  if (url.includes("localhost" || "test")) {
    domain = "https://recruiter.foundit.in";
  } else {
    domain = window.location.origin;
  }
  return domain;
};

export const buildQueryString = (params: { [key: string]: any }): string => {
  const queryString = Object.keys(params).filter(i => params[i] != null)
    .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
    .join('&');
  return queryString;
}


export const removeErrorSpan = (stringA: string, stringB: string) => {
  const parser = new DOMParser();
  const docA = parser.parseFromString(stringA, 'text/html');
  const docB = parser.parseFromString(stringB, 'text/html');

  const spansA = docA.querySelectorAll('span');
  const spansB = docB.querySelectorAll('span');
  if (spansA.length === spansB?.length) {
    for (let i = 0; i < spansA.length; i++) {
      const textA = spansA[i].textContent;
      const textB = spansB[i].textContent;

      if (textA !== textB) {
        const innerContent = textB !== null ? document.createTextNode(textB) : null;
        const parent = spansB[i].parentNode;
        if (innerContent && parent) {
          parent.replaceChild(innerContent, spansB[i]);
        } else if (parent) {
          parent.removeChild(spansB[i]);
        }
      }
    }
  }
  // Convert the modified DOM back to an HTML string
  const modifiedString = docB.body.innerHTML;
  return modifiedString;
}


// export const sanitizeHtml = (inputHtml : string, profanityWordsInSelectedTab: string[]) => {
//   const doc = new DOMParser().parseFromString(inputHtml, 'text/html');
//   const spanElements = doc.querySelectorAll('span');
//   const fontElements = doc.querySelectorAll('font');

//   // Remove <span> elements if found
//   if (spanElements) {
//     spanElements.forEach((span,index) => {
//       const text = spanElements[index].textContent;
//       const isNotProfanityWord = profanityWordsInSelectedTab.some((word: string) => word !== text);
//       const innerContent = text !== null ? document.createTextNode(text) : null;
   
//       if (span.parentNode && innerContent && isNotProfanityWord) {
//         span.parentNode.replaceChild(innerContent, spanElements[index]);
//       }
//     });
//   }

//    // Remove the 'color' attribute from <font> elements if found
//    if (fontElements) {
//     fontElements.forEach((font) => {
//       if (font.hasAttribute('color')) {
//         font.removeAttribute('color');
//       }
//     });
//   }

//   return doc.body.innerHTML;
// };



/**
 * returns the url for the image, created from File obj
 * @param fileObj Object
 * @returns String
 */
export const getImageUrlFromFileObj = (fileObj: Blob | MediaSource) => {
  return window.URL.createObjectURL(fileObj);
}

export const getBase64 = (file: File) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
}

export const checkMediaSize = (media: FileList | null): boolean => {
  if (!media || media.length === 0) {
    return true; // No files or no FileList provided, consider it valid.
  }

  let totalSizeInBytes = 0;
  const oneMBInBytes = 1024 * 1024;

  for (let i = 0; i < media.length; i++) {
    totalSizeInBytes += media[i].size;
  }

  // Check if the total size is <= 1MB
  return totalSizeInBytes <= oneMBInBytes;
};


export const getDateRange = (dateValue: string, customDate: any) => {
  const now = new Date();
  let startDate = '';
  let endDate = '';

  switch (dateValue) {
    case 'Last 24 hours':
      startDate = new Date(now.getTime() - 24 * 60 * 60 * 1000).toISOString();
      endDate = now.toISOString();
      break;
    case 'Last 3 days':
      startDate = new Date(now.getTime() - 3 * 24 * 60 * 60 * 1000).toISOString();
      endDate = now.toISOString();
      break;
    case 'Last 7 days':
      startDate = new Date(now.getTime() - 7 * 24 * 60 * 60 * 1000).toISOString();
      endDate = now.toISOString();
      break;
    case 'Last 1 month':
      startDate = new Date(now.getFullYear(), now.getMonth() - 1, now.getDate()).toISOString();
      endDate = now.toISOString();
      break;
    case 'Last 3 months':
      startDate = new Date(now.getFullYear(), now.getMonth() - 3, now.getDate()).toISOString();
      endDate = now.toISOString();
      break;
    case 'Last 6 months':
      startDate = new Date(now.getFullYear(), now.getMonth() - 6, now.getDate()).toISOString();
      endDate = now.toISOString();
      break;
    case 'Custom Date':
      if (customDate && (customDate.from || customDate.to)) {
        startDate = customDate.from ? new Date(customDate.from).toISOString() : '';
        endDate = customDate.to ?  new Date(customDate.to).toISOString() : '';
      }
      break;
    default:
      // Handle any other cases or set startDate and endDate to appropriate values.
  }

  return { startDate, endDate };
};

export const getGtmIdForSiteContext = (siteContext: string) => {
  switch (siteContext) {
    case 'monstergulf':
      return 'GTM-TGMWFHT';
    case 'monstersingapore':
      return 'GTM-WXW3G7';
    case 'monsterthailand':
      return 'GTM-W4XCF74';
    case 'monsterphilippines':
      return 'GTM-NCB6SR';
    case 'monstervietnam':
      return 'GTM-TJ7F7ZH';
    case 'monstermalaysia':
      return 'GTM-57CQ4N';
    case 'monsterindonesia':
      return 'GTM-MGZV4PL';
    case 'monsterhongkong':
      return 'GTM-KWGPLKK';
    case 'rexmonster':
      return 'GTM-NGL6ZM';
    default:
      break;
  }
}

export const getHealthApiPayload = (status: number, queryObject: any, startTime: Date, recruiterId: any, pageName: string) => {
  let  HTMLresponseEnd = 0;
  let domInteractiveTime = 0;
  let serverResponseTime = 0;
  let endDate = Date.now();

  if (window.performance && window.performance.getEntriesByType) {
    const entries = window.performance.getEntriesByType('navigation');
    if (entries.length > 0) {
        const navTiming = entries[0] as PerformanceNavigationTiming;
        serverResponseTime =  navTiming.responseEnd - navTiming.requestStart;
        serverResponseTime = Math.round(((serverResponseTime / 1000) + Number.EPSILON) * 100) / 100;
        if (navTiming.loadEventEnd) {
            HTMLresponseEnd = navTiming.responseEnd
            domInteractiveTime = navTiming.domInteractive
        }
    }
}


  const timeDiff = (endDate - startTime.getTime())/1000;
  return {
    query: JSON.stringify(queryObject),
    pageStatus : status,
    pageLoadStartTime : `${new Date((window as any).startTime - HTMLresponseEnd)}`,
    pageLoadEndTime : `${new Date(endDate)}`,
    pageName: pageName,
    pageURL: window.location.href,
    subUID : recruiterId,
    pageLoadTime : timeDiff,
    timeOfInteraction: domInteractiveTime/1000,
    totalLoadTime: (endDate - ((window as any).startTime) + HTMLresponseEnd) / 1000,
    serverResponseTime: serverResponseTime
  }
 
}

export const getCurrencyHexCode = (currency: string) => {
  switch(currency){
    case 'SGD':
      return '&#x53;&#x24;';
    case 'MYR':
      return '&#x52;&#x4d;';
    case 'HKD':
      return '&#x24;'; 
    case 'IDR':
      return '&#x52;&#x70;';
    case 'PHP':
      return '&#x20b1;';
    case 'THB':
      return '&#xe3f;';
    case 'VND':
      return '&#x20ab;';
      case 'Dirhams':
      return 'Dirhams';
    case 'Bahraini Dirhams':
      return 'Bahraini Dirhams';
    case 'Jordanian Dinars':
      return 'Jordanian Dinars';
    case 'Kuwaiti Dinars':
      return 'Kuwaiti Dinars';
    case 'Lebanese Pounds':
      return 'Lebanese Pounds';
    case 'Omani Riyals':
      return 'Omani Riyals';
    case 'Pataca':
      return 'Pataca'; 
    case 'Qatari Riyals':
      return 'Qatari Riyals';
    case 'Saudi Riyals':
      return 'Saudi Riyals';
    case 'US Dollar':
      return 'US Dollar';
    case 'Yuan Renminbi':
      return 'Yuan Renminbi';
    case 'Taiwan Dollar':
        return 'Taiwan Dollar';
    default: 
    return '&#x20b9;';
  }
}
export const updateCampaignPlaceholderValues = (htmlString: string, isPreview: boolean) => {
  // Create a temporary div element
  const tempDiv = document.createElement('div');

  // Set the HTML content of the div to the provided string
  tempDiv.innerHTML = htmlString;

  // Select all spans containing keywords
  const spansWithKeywords = tempDiv.querySelectorAll('span');

  // Iterate over each span
  spansWithKeywords.forEach(span => {
      // Get the inner text of the span
      const spanText = span.innerText.trim();
      // Iterate over the keywords array
      CAMPAIGN_PLACEHOLDERS.forEach(word => {
          // Check if the span text contains the keyword
          if (spanText.includes(word)) {
              const keyword = `${word}:`;
              // Replace the span with only the value after the keyword
              const keywordIndex = spanText.indexOf(keyword);
              const valueAfterKeyword = spanText.substring(keywordIndex + keyword.length).trim();
              const newSpan = document.createElement('span');
              newSpan.innerHTML = valueAfterKeyword
              valueAfterKeyword && span.replaceWith(newSpan);
          }
      });

     !isPreview && Object.entries(placeholderMapping).forEach(([text,htmlContent]) => {
        if(text.includes(spanText)){
          const newSpan = document.createElement('span');
          newSpan.innerHTML = spanText
          span.replaceWith(newSpan);
        }
      })
  });

   // Select all spans with the specific identifier (class or attribute)
   const highlightedSpans = tempDiv.querySelectorAll('span.highlighted');
    if(highlightedSpans && highlightedSpans.length > 0){
      highlightedSpans.forEach(span => {
        const spanText = span.textContent?.trim() || '';
        const newSpan = document.createElement('span');
        newSpan.innerHTML = spanText;
        span.replaceWith(newSpan);
      }); 
    }

  // Return the modified HTML content
  return tempDiv.innerHTML;
}


export const getCurrencyBasedOnSiteContext = (siteContext: string) => {
  switch (siteContext) {
    case 'rexmonster':
      return 'INR';
    case 'monstergulf':
      return 'US Dollar';
    case 'monstersingapore':
      return 'SGD';
    case 'monsterthailand':
      return 'THB';
    case 'monsterphilippines':
      return 'PHP';
    case 'monstervietnam':
      return 'VND';
    case 'monstermalaysia':
      return 'MYR';
    case 'monsterindonesia':
      return 'IDR';
    case 'monsterhongkong':
      return 'HKD';
    default:
      break;
  }
}

export const getCurrencyFromHexCode = (hexCode: string): string => {
  switch (hexCode) {
    case '&#x53;&#x24;': return 'SGD';
    case '&#x52;&#x4d;': return 'MYR';
    case '&#x24;': return 'HKD';
    case '&#x52;&#x70;': return 'IDR';
    case '&#x20b1;': return 'PHP';
    case '&#xe3f;': return 'THB';
    case '&#x20ab;': return 'VND';
    case 'Dirhams': return 'AED';
    case 'Bahraini Dinars': return 'BHD';
    case 'Jordanian Dinars': return 'JOD';
    case 'Kuwaiti Dinars': return 'KWD';
    case 'Lebanese Pounds': return 'LBP';
    case 'Omani Riyals': return 'OMR';
    case 'Pataca': return 'MOP';
    case 'Qatari Riyals': return 'QAR';
    case 'Saudi Riyals': return 'SAR';
    case 'US Dollar': return 'USD';
    case 'Yuan Renminbi': return 'CNY';
    case 'Taiwan Dollar': return 'TWD';
    case '&#x20b9;': return 'INR';
    default: return '';
  }
};

export const getHexCodeFromCurrency = (currency: string): string => {
  switch (currency) {
    case 'SGD': return '&#x53;&#x24;';
    case 'MYR': return '&#x52;&#x4d;';
    case 'HKD': return '&#x24;';
    case 'IDR': return '&#x52;&#x70;';
    case 'PHP': return '&#x20b1;';
    case 'THB': return '&#xe3f;';
    case 'VND': return '&#x20ab;';
    case 'AED': return 'Dirhams';
    case 'BHD': return 'Bahraini Dinars';
    case 'JOD': return 'Jordanian Dinars';
    case 'KWD': return 'Kuwaiti Dinars';
    case 'LBP': return 'Lebanese Pounds';
    case 'OMR': return 'Omani Riyals';
    case 'MOP': return 'Pataca';
    case 'QAR': return 'Qatari Riyals';
    case 'SAR': return 'Saudi Riyals';
    case 'USD': return 'US Dollar';
    case 'CNY': return 'Yuan Renminbi';
    case 'TWD': return 'Taiwan Dollar';
    case 'INR': return '&#x20b9;';
    default: return '&#x20b9;';
  }
};



export const getCurrencyBySiteContext = (siteContext: string) => {
  switch (siteContext) {
    case 'rexmonster':
      return 'INR';
    case 'monstergulf':
      return 'USD';
    case 'monstersingapore':
      return 'SGD';
    case 'monsterthailand':
      return 'THB';
    case 'monsterphilippines':
      return 'PHP';
    case 'monstervietnam':
      return 'VND';
    case 'monstermalaysia':
      return 'MYR';
    case 'monsterindonesia':
      return 'IDR';
    case 'monsterhongkong':
      return 'HKD';
    default:
      break;
  }
}
export const getCurrencySymbol = (currency: string): string => {
  switch (currency) {
    case 'INR': return '₹';
    case 'SGD': return 'S$';
    case 'MYR': return 'RM';
    case 'HKD': return 'HK$';
    case 'IDR': return 'Rp';
    case 'PHP': return '₱';
    case 'THB': return '฿';
    case 'VND': return '₫';
    case 'AED': return 'Dirhams';
    case 'BHD': return 'Bahraini Dinars';
    case 'JOD': return 'Jordanian Dinars';
    case 'KWD': return 'Kuwaiti Dinars';
    case 'LBP': return 'Lebanese Pounds';
    case 'OMR': return 'Omani Riyals';
    case 'MOP': return 'Pataca';
    case 'QAR': return 'Qatari Riyals';
    case 'SAR': return 'Saudi Riyals';
    case 'USD': return 'US Dollar';
    case 'CNY': return 'Yuan Renminbi';
    case 'TWD': return 'Taiwan Dollar';
    default: return '';
  }
};

export const getFounditDomain = (url: string) => {
  let domain = '';
  if(url){
    domain = url.split('.').slice(-2).join('.');
  }
  return domain;
}

export const filterObject = (obj: {[key: string]: any}) => {
  for (let key in obj) {
      if (obj[key] !== null && obj[key] !== undefined) {
          return obj; 
      }
  }
  return false;
}

export const prefillFields: any = (dispatch: any, objectArray: {value: any, key: string, dispatchFunction: any}[]) => {
  objectArray.forEach( object => {
    const {value, key, dispatchFunction} = object
    if(value != undefined) {
      dispatch(dispatchFunction({[key]: value || ''}))
    }
  })
}

export const capitalizeSentences = (text: string) => {
  return text.replace(/(^|\.\s+)([a-z])/g, (match) => match.toUpperCase());
};

export function convertToDivs(element: HTMLElement) {
  element.childNodes.forEach((node) => {
    if (node.nodeType === Node.ELEMENT_NODE) {
      const el = node as HTMLElement;
   
      if(el.tagName.toLowerCase() === "ul"){
        const ul = document.createElement("ul");
        ul.style.fontSize = "1.4rem !important";
        ul.style.lineHeight = "3rem !important";
        ul.innerHTML = capitalizeSentences(el.innerHTML);
        el.parentNode?.replaceChild(ul, el);
        ul.childNodes.forEach((item) => {
          const li = document.createElement("li");
          li.style.fontSize = "1.4rem !important";
          li.style.lineHeight = "3rem !important";
          li.innerHTML = item.textContent ? capitalizeSentences(item.textContent) : '';
          item.parentNode?.replaceChild(li, item);
        })
      } 
      else if (el.tagName.toLowerCase() !== "li") {
        const div = document.createElement("div");
        div.style.fontSize = "1.4rem !important";
        div.style.lineHeight = "3rem !important";
        div.innerHTML = capitalizeSentences(el.innerHTML);
        el.parentNode?.replaceChild(div, el);
        div.childNodes.forEach((item) => {
          const div = document.createElement("div");
          div.style.fontSize = "1.4rem !important";
          div.style.lineHeight = "3rem !important";
          div.innerHTML =item.textContent ? capitalizeSentences(item.textContent) : '';
          item.parentNode?.replaceChild(div, item);
        })
      }
      
      else {
        convertToDivs(el); // Recursively handle child nodes
      }
    }
  });
}

export const stripHtml =(html: string) => {
  return html.replace(/<[^>]*>/g, '');
}

  // Helper function to determine if an option should be disabled
 export const isSalaryOptionDisabled = (option: any, salary: string, isMin: boolean) => {
    if(isMin){
     return parseInt(removeCommas(option.value)) >= parseInt(removeCommas(salary))
    }
    else
    return parseInt(removeCommas(option.value)) <= parseInt(removeCommas(salary));
  };

  // Helper function to check if the value is less than minSalary
 export const isValidSalaryValue = (value: string, salary: string, isMin: boolean): boolean => {
    if (salary === null || salary === '') {
      return true;
    }
    if(isMin){
      return parseInt(removeCommas(value)) < parseInt(removeCommas(salary));
    }
    else{
      return parseInt(removeCommas(value)) > parseInt(removeCommas(salary));
    }
  };

  // If you need a function to format the numbers dynamically
// export const formatNumberWithCommas = (number: string) => {
//   return number.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
// };

export const formatNumberWithCommas = (number: string, useStandard: boolean) => {
  let formattedNumber;
  let initialNumber = number;
  if(initialNumber.includes(',') || initialNumber.includes('₹')){
    initialNumber = removeCommas(initialNumber)
  }
 
  if (useStandard) {
    formattedNumber = initialNumber.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  } else {
    // Split number into two parts: the part that needs pairs and the last three digits
    let lastThreeDigits = initialNumber.slice(-3);
    let otherDigits = initialNumber.slice(0, -3);

    // Format the part before the last three digits with pairs
    if (otherDigits) {
      otherDigits = otherDigits.replace(/\B(?=(\d{2})+(?!\d))/g, ',');
      formattedNumber = otherDigits + ',' + lastThreeDigits;
    } else {
      // If there are no other digits, just return the last three digits
      formattedNumber = lastThreeDigits;
    }
    
    // Add the rupee symbol
    formattedNumber = '₹' + formattedNumber;
  }

  return formattedNumber;
};

export const removeCommas = (numberWithCommas: string) => {
  return numberWithCommas.replace(/,|₹/g, '');
};

export const returnSingularOrPlural = (variable: number, singularWord: string, pluralWord: string ) : string => {
if( variable > 1) { return pluralWord}
else { return singularWord }
}

export const runContentReveal = (revealContent: string, state: React.Dispatch<React.SetStateAction<string>>, revealed: React.Dispatch<React.SetStateAction<boolean>>, actionsOnFulfill: Function) => {
 
  revealed(false);
  state("");
    
  actionsOnFulfill()

};

export const replaceSpansWithPlaceholders = (input: string): string => {
  return input.replace(/<span data-content="([^"]+)"[^>]*>(.*?)<\/span>/g, '$1');
};


export const replaceDetails = (msg: string, jobTitle: string, minExperience: string, maxExperience:string, candidateFullName?:string) => {
  let result = msg;

  if(!result.includes('data-content="@fullName"')){
    result = result?.replaceAll("@fullName", `<span data-content="@fullName" contenteditable = 'false' style="font-weight: 700">${candidateFullName||""}</span>`)
  }

  if(!result.includes('data-content="@jobTitle"')){
    result = result?.replaceAll("@jobTitle", `<span data-content="@jobTitle" contenteditable = 'false' style="font-weight: 700">${jobTitle||""}</span>`)
  }

  if(!result.includes('data-content="@reqexpRange"')){
    result = result?.replaceAll("@reqexpRange", `<span  data-content="@reqexpRange" contenteditable = 'false' style="font-weight: 700">${minExperience} ${returnSingularOrPlural(Number(minExperience), 'year', 'years')} to ${maxExperience} ${returnSingularOrPlural(Number(maxExperience), 'year', 'years')}</span>`);
  }
  // return msg
  // ?.replaceAll("@fullName", `<span data-content="@fullName" contenteditable = 'false' style="font-weight: 700">${candidateFullName||""}</span>`)
  // ?.replaceAll("@jobTitle", `<span  data-content="@jobTitle" contenteditable = 'false' style="font-weight: 700">${jobTitle}</span>`)
  // ?.replaceAll("@reqexpRange", `<span  data-content="@reqexpRange" contenteditable = 'false' style="font-weight: 700">${minExperience} ${returnSingularOrPlural(Number(minExperience), 'year', 'years')} to ${maxExperience} ${returnSingularOrPlural(Number(maxExperience), 'year', 'years')}</span>`)

  return result;
}
export const checkForEmptyContent = (content: string) => {
  // Remove all HTML tags and non-breaking spaces
  const strippedContent = content.replace(/<[^>]*>|&nbsp;/g, '');
  // Remove whitespace characters
  const strippedContentWithoutSpaces = strippedContent.replace(/\s/g, '');
  return strippedContentWithoutSpaces === '';
}


export const checkForUrlAndEmail = (content: string) => {  
  // Refined regex pattern for matching emails with multiple domains
  const emailWithMultipleDomainsRegex = /\b[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,7}(\.[A-Za-z]{2,7})+\b/g;

  // Regex to check if the email is already highlighted
  const highlightedRegex = /<span[^>]*class=['"]highlighted['"][^>]*>.*<\/span>/;

  // Check if the content contains an email with multiple domains
  const containsEmail = emailWithMultipleDomainsRegex.test(content);

  // Check if the email is already highlighted
  const alreadyHighlighted = highlightedRegex.test(content);

  // Return true if the email with multiple domains is present and not highlighted
  return containsEmail && !alreadyHighlighted;
}


export const replaceUrlEmailWithPlainText = (input: string) => {
  // Refined regex pattern for matching emails with multiple domains
  const emailWithMultipleDomainsRegex = /\b[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,7}(\.[A-Za-z]{2,7})+\b/g;

  // Function to wrap matched emails with a styled span without changing the text
  const highlightEmail = (email: string) => {
    // Insert zero-width spaces to prevent automatic link conversion
    const encodedEmail = email.replace(/@/g, '&#8203;@').replace(/\./g, '&#8203;.');
    return `<span class='highlighted' style="color: #E03923; padding: 2px; background-color: #FCEBE9">${encodedEmail}</span>`;
  };

  // Replace emails with multiple domains with their highlighted span versions
  input = input.replace(emailWithMultipleDomainsRegex, match => highlightEmail(match));

  return input || '';
};



export const replaceAnchorTagsWithPlainText = (input: string) => {
  // Function to create a styled span
  const createStyledSpan = (text: string) => {
    const span = document.createElement('span');
    span.className = 'highlighted';
    span.style.color = '#E03923';
    span.style.padding = '2px';
    span.style.backgroundColor = '#FCEBE9';

    // Insert zero-width spaces to break Gmail's link detection
    const encodedText = text.replace(/@/g, '<span>&#8203;@</span>').replace(/\./g, '<span>&#8203;.</span>');

    span.innerHTML = encodedText;
    return span;
  };

  // Create a temporary DOM element to parse the HTML string
  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = input;

  // Regular expression to match an email with multiple domains
  const emailWithMultipleDomainsRegex = /^[^\s@]+@[^@]+\.[^@]+(\.[^@]+)+$/;

  // Function to process anchor tags
  const processNodes = (node: Node) => {
    if (node.nodeType === Node.ELEMENT_NODE) {
      const element = node as HTMLElement;

      if (element.tagName === 'A') {
        const anchor = element as HTMLAnchorElement;
        const href = anchor.getAttribute('href') || '';
        const anchorText = anchor.textContent || '';

        // Check if the href is a mailto link with an email containing multiple domains
        if (href.startsWith('mailto:')) {
          const email = href.replace('mailto:', '');
          if (emailWithMultipleDomainsRegex.test(email)) {
            // Create a new span with the same text content as the anchor, but with zero-width spaces
            const newSpan = createStyledSpan(anchorText);

            // Replace the anchor tag with the new span
            anchor.replaceWith(newSpan);
          }
        }
      } else {
        // Process child nodes recursively
        element.childNodes.forEach(processNodes);
      }
    }
  };

  // Process all 
  tempDiv.childNodes.forEach(processNodes);

  // Return the modified HTML content
  return tempDiv.innerHTML;
};

export const getSalaryWitComma = (salary:any) => {
  let salaryString = salary.toString().replaceAll(',', '').replace('₹', '');
  let salary_ = Number(salaryString)
  if(salary && salary_ > 0){
    return salary_?.toLocaleString("en-IN")
  }else{
    return null
  }
}


export const getFormData = (payload: any)=>{
  const formData = new FormData();
  formData.append("campaignFormRequest", JSON.stringify(payload));

  // to convert json object into form data
  // const formData = new FormData();

  // Object.keys(payload).forEach((key) => {
  //   const value = payload[key];
  
  //   if (typeof value === "object" && value !== null) {
  //     // handle nested objects
  //     if (Array.isArray(value)) {
  //       value.forEach((item) => {
  //         formData.append(`${key}[]`, item); // For arrays
  //       });
  //     } else {
  //       // for nested objects, use a recursive approach to flatten them
  //       Object.keys(value).forEach((nestedKey) => {
  //         const nestedValue = value[nestedKey as keyof typeof value];
  //         formData.append(`${key}[${nestedKey}]`, nestedValue || "");
  //       });
  //     }
  //   } else {
  //     // For primitive types
  //     formData.append(key, typeof value !== "undefined" ? value : "");
  //   }
  // });

  return formData;
}


export const formatNumber = (num: number, format: 'international' | 'indian'): string => {
  if (format === 'international') {
    if (num >= 1e12) return `${(num / 1e12).toFixed(1).replace(/\.0$/, '')}T`; // Trillion
    if (num >= 1e9) return `${(num / 1e9).toFixed(1).replace(/\.0$/, '')}B`;  // Billion
    if (num >= 1e6) return `${(num / 1e6).toFixed(1).replace(/\.0$/, '')}M`;  // Million
    if (num >= 1e3) return `${(num / 1e3).toFixed(1).replace(/\.0$/, '')}K`;  // Thousand
  } else if (format === 'indian') {
    if (num >= 1e7) return `${(num / 1e7).toFixed(1).replace(/\.0$/, '')}CR`;  // Crore
    if (num >= 1e5) return `${(num / 1e5).toFixed(1).replace(/\.0$/, '')}L`;   // Lakh
    if (num >= 1e3) return `${(num / 1e3).toFixed(1).replace(/\.0$/, '')}K`;   // Thousand
  }
  return num.toString();
};

export function extractBaseServer(url:string) {
  if (url.includes("localhost") || url.includes("test") ) {
    url = "recruiter.foundit.in";
  }
 
  const parts = url.split('.');
  const domain = parts[parts.length - 2] + '.' + parts[parts.length - 1];
 
  return domain;
}

// export const isValidEmail = (email: string, maxLength: number = 320): boolean => {
//   const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//   return email.length <= maxLength && emailRegex.test(email);
// };

export const isValidEmail = (email: string): boolean => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  if (!emailRegex.test(email)) return false; 

  const [localPart, domainPart] = email.split("@");

  return localPart.length <= 64 && domainPart.length <= 255;
};

type ChannelKey = "sea" | "in" | "emom";

export interface ChannelInfo {
  channelId: number | null;
  domain:string
}

export const getChannelId = (cn:string): ChannelInfo => {
const channelMap: Record<ChannelKey, ChannelInfo> = {
    sea: { channelId: 4,domain:'https://recruiter.foundit.sg' },
    in: { channelId: 1,domain:'https://recruiter.foundit.in' },
    emom: { channelId: 2,domain:'https://recruiter.founditgulf.com' }
  };

  const key = cn?.toLowerCase().trim() as ChannelKey;
  const result = channelMap[key];

  if (!result) {
    return {channelId : null,domain: window.location.origin};
  }

  return result;

}

export interface ChannelInfo {
  channelId: number | null;
}

export function getDisabledFields(obj: DisabledFieldsType): (keyof DisabledFieldsType)[] {
  return (Object.keys(obj) as (keyof DisabledFieldsType)[])
    .filter((key) => obj[key] === true);
}